import { render, staticRenderFns } from "./cardProducto.vue?vue&type=template&id=02acbfde&scoped=true"
import script from "./cardProducto.vue?vue&type=script&lang=js"
export * from "./cardProducto.vue?vue&type=script&lang=js"
import style0 from "./cardProducto.vue?vue&type=style&index=0&id=02acbfde&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02acbfde",
  null
  
)

export default component.exports